import { Button } from "@kalodata/kds-design";
import { IconLinePlus } from "@kalodata/kds-design-icons";
import { TestId } from "@shared/testIds";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";

export type PostVideoButtonVariant = "floating" | "primary";

const variantClassName: Record<PostVideoButtonVariant, string> = {
  floating: "bg-kds-bg-element text-kds-fg border border-kds-border-solid",
  primary:
    "h-[40px] bg-kds-dark-reverse text-kds-light-reverse shadow-[0_1px_3px_0_var(--kds-shadow)] hover:bg-(--palette-slate-11) hover:text-kds-light-reverse",
};

export interface PostVideoButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  variant?: PostVideoButtonVariant;
  className?: string;
  "data-testid"?: string;
}

export const PostVideoButton = ({
  onClick,
  disabled,
  variant = "floating",
  className,
  "data-testid": dataTestId = TestId.SocialPublisherPostVideo,
}: PostVideoButtonProps) => {
  return (
    <Button
      size="lg"
      iconPlacement="start"
      icon={<IconLinePlus size={20} />}
      disabled={disabled}
      className={twMerge(variantClassName[variant], className)}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <Trans>Post video</Trans>
    </Button>
  );
};
